import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class Extrafinancial extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  extraFinancialState: this.props.extraFinancial,
                  selectedThirdpartyCoverage: {
                        value: this.props.extraFinancial.extrafinancial_thirdparty_coverage_id,
                        label: this.props.extraFinancial.thirdparty_coverage_name,
                  },
                  selectedThirdpartyCalmode: {
                        value: this.props.extraFinancial.extrafinancial_extrafinancial_calmode_id,
                        label: this.props.extraFinancial.extrafinancial_calmode_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }
      componentDidMount() {
            this.getoptionThirdpartyCoverage()
            this.getoptionThirdpartyCalmode()
      }

      getoptionThirdpartyCoverage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].thirdparty_coverage_id, label: arr.data[k].thirdparty_coverage_name })
                              }
                              self.setState({ optionThirdpartyCoverage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.send(fd)
      }

      getoptionThirdpartyCalmode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].extrafinancial_calmode_id, label: arr.data[k].extrafinancial_calmode_name })
                              }
                              self.setState({ optionThirdpartyCalmode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_extrafinancial_calmode")
            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedThirdpartyCoverage) => {
            var temparray = this.state.extraFinancialState
            temparray.extrafinancial_thirdparty_coverage_id = selectedThirdpartyCoverage.value
            this.setState({ selectedThirdpartyCoverage: selectedThirdpartyCoverage, extraFinancialState: temparray })
      }

      handleCalmode = (selectedThirdpartyCalmode) => {
            var temparray = this.state.extraFinancialState
            temparray.extrafinancial_thirdparty_coverage_id = selectedThirdpartyCalmode.value
            this.setState({ selectedThirdpartyCalmode: selectedThirdpartyCalmode, extraFinancialState: temparray })
      }

      handleChangeExtrafinancialPerice = (event) => {
            var temparray = this.state.extraFinancialState
            temparray.extrafinancial_price = event
            this.setState({ extraFinancialState: temparray })
      }

      handleChangeExtrafinancialPercent = (event) => {
            var temparray = this.state.extraFinancialState
            temparray.extrafinancial_percent = event
            this.setState({ extraFinancialState: temparray })
      }
      handleChangeExtrafinancialstatus = (event) => {
            // مقدار جدید را از event.target.checked می‌گیریم
            const isChecked = event.target.checked;

            // تبدیل مقدار بولین به "0" یا "1"
            const newStatus = isChecked ? "1" : "0";

            // به‌روزرسانی وضعیت state
            this.setState((prevState) => ({
                  extraFinancialState: {
                        ...prevState.extraFinancialState,
                        extrafinancial_status: newStatus,
                  },
            }));
      };

      modifyNewInstalmentCondition = () => {
            const { extraFinancialState, selectedThirdpartyCalmode } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_extrafinancial")
            fd.append("extrafinancial_id", extraFinancialState.extrafinancial_id)
            fd.append("extrafinancial_price", extraFinancialState.extrafinancial_price)
            fd.append("extrafinancial_percent", extraFinancialState.extrafinancial_percent)
            fd.append("extrafinancial_status", extraFinancialState.extrafinancial_status)
            fd.append("extrafinancial_extrafinancial_calmode_id", selectedThirdpartyCalmode.value)

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { extraFinancialState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_extrafinancial")
            fd.append("extrafinancial_id", extraFinancialState.extrafinancial_id)

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {
                  optionThirdpartyCoverage,
                  optionThirdpartyCalmode,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedThirdpartyCoverage,
                  selectedThirdpartyCalmode,
                  extraFinancialState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid item xs={2}>
                                    <div>
                                          <label className="on"> پوشش مالی</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"پوشش مالی"}
                                                value={selectedThirdpartyCoverage}
                                                onChange={this.handleInstalmentMode}
                                                options={optionThirdpartyCoverage}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="قیمت مازاد مالی"
                                          type="currency"
                                          handleInputt={this.handleChangeExtrafinancialPerice}
                                          value={extraFinancialState.extrafinancial_price}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          placeholder="تخفیف مازاد مالی"
                                          type="percent"
                                          handleInputt={this.handleChangeExtrafinancialPercent}
                                          value={extraFinancialState.extrafinancial_percent}
                                    />
                              </Grid>
                              <Grid item xs={2}>
                                    {/*<FloatingLabelInput*/}
                                    {/*      placeholder="کتک"*/}
                                    {/*      type="percent"*/}
                                    {/*      handleInputt={this.handleChangeExtrafinancialstatus}*/}
                                    {/*      value={extraFinancialState.extrafinancial_status}*/}
                                    {/*/>*/}
                                    <FormControlLabel
                                        control={
                                              <Switch
                                                  checked={extraFinancialState.extrafinancial_status === "0" ? false : true}
                                                  onChange={this.handleChangeExtrafinancialstatus}
                                                  name="extrafinancial_status"
                                              />
                                        }
                                        label="تخفیف نقدی"
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <div>
                                          <label className="on">مدل محاسبه</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"مدل محاسبه"}
                                                value={selectedThirdpartyCalmode}
                                                onChange={this.handleCalmode}
                                                options={optionThirdpartyCalmode}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={2}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(Extrafinancial)
